var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M118.947 13.279a15.218 15.218 0 00-10.741-10.74C98.732 0 60.742 0 60.742 0S22.753 0 13.279 2.539a15.215 15.215 0 00-10.74 10.74C0 22.753 0 42.52 0 42.52s0 19.767 2.539 29.241a15.211 15.211 0 0010.74 10.74c9.474 2.539 47.463 2.539 47.463 2.539s37.99 0 47.464-2.539a15.216 15.216 0 0010.741-10.74c2.538-9.474 2.538-29.241 2.538-29.241s0-19.767-2.538-29.241M48.594 60.743V24.297L80.156 42.52 48.594 60.743z"}));
}

Youtube.defaultProps = {"width":"121.485","height":"85.04","viewBox":"0 0 121.485 85.04"};

module.exports = Youtube;

Youtube.default = Youtube;
